import { createAppStore } from '@app/core/stores';

interface UiState {
  sidenavOpen: boolean;
  /** Timestamp when the full version alert was last shown (for 24h cooldown). */
  versionCheckLastAlertShownAt: number | null;
  // Actions
  toggleSidenav: (open?: boolean) => void;
  /** Records that the full version alert was shown; used for 24h cooldown. */
  markVersionAlertShown: () => void;
}

/**
 * Zustand store for managing UI state.
 * Replaces the Redux implementation with a simpler Zustand store.
 */
export const useUiStore = createAppStore<UiState>('UiStore', {
  persist: { name: 'app.ui', version: 2, purgeOnLogout: false },
})((set) => ({
  // Initial state
  sidenavOpen: true,
  versionCheckLastAlertShownAt: null,

  // Toggle sidenav - if boolean provided, set to that value, otherwise toggle
  toggleSidenav: (open) => {
    set((state) => ({
      sidenavOpen: open !== undefined ? open : !state.sidenavOpen,
    }));
  },

  markVersionAlertShown: () => {
    set({ versionCheckLastAlertShownAt: Date.now() });
  },
}));
